export let overtimeListProps = {
    key: 0,
    id: 0,
    overtime_id: null,
    overtime_pay_amount: 0
}

export let productionPieceRateListProps = {
    key: 0,
    id: 0,
    tailoring_category_id: null,
    tailoring_sub_category_id: null,
    tailoring_item_id: null,
    piece_rate_type: 0, //fixed or percent of stitching price
    trial_finish_rate: 0,
    half_finish_rate: 0,
    piece_rate: 0,
    alteration_rate: 0,
    trial_type_price_list: [],
    master_rate: true,
    required_minutes: 0,
    required_minutes_trial: 0
}

export let dataProps = {
    id: 0,
    active: true, 
    staff_type: 0,  //0=regular employee, 1=contractor
    is_sales_person: false,
    is_system_user: false, 
    is_production_member: false, 
    is_a_production_supervisor: false,
    staff_name: '', 
    alias_name: '',
    present_address: '', 
    permanent_address: '', 
    contact_number: '', 
    email_address: '', 
    can_take_measurement: false, 
    can_assist_trial: false, 
    date_of_joining: new Date(), 
    designation_id: null, 
    fixed_salary: 0,
    deduction_per_day: 0, 
    additional_notes: '', 
    current_store_id: null, 
    profile_photo: '', 
    recommended_by: '',
    in_time: '',
    out_time: '',
    hour_rate: 0,
    discount_cap: 0,
    
    user_id: 0,
    user_name: '',
    user_password: '',
    user_group_id: null,
    user_access_store: [],
    ip_restriction_not_applied: false,
    religion: 0,
    is_qc_manager: false,

    overtime_list: [JSON.parse(JSON.stringify(overtimeListProps))],
    deleted_overtime_list: [],

    production_process_list: [],
    tax_list: [],
    lunch_start_time: '',
    lunch_end_time: '',
    account_sub_category_id: null,
    kra: '',
    supervising_process_id: 0,
    bank_detail: '',
    bank_code: '',
    bank_name: '',
    bank_account_number: '',
    account_related_sub_category_id: null,
    
    production_piece_rate_list: [JSON.parse(JSON.stringify(productionPieceRateListProps))],
    deleted_production_piece_rate_list: [],
    allowed_to_mo_order: true
}


// WEBPACK FOOTER //
// ./src/store/modules/employee/properties.js